/**
* @fileoverview This file is generated by the Angular template compiler.
* Do not edit.
* @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
* tslint:disable
*/ 
import * as i0 from "./chips-list-notResponsive.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./chips-list-notResponsive.component";
var styles_ChipsListNotResponsiveComponent = [i0.styles];
var RenderType_ChipsListNotResponsiveComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_ChipsListNotResponsiveComponent, data: {} });
export { RenderType_ChipsListNotResponsiveComponent as RenderType_ChipsListNotResponsiveComponent };
export function View_ChipsListNotResponsiveComponent_0(_l) { return i1.ɵvid(0, [i1.ɵncd(null, 0)], null, null); }
export function View_ChipsListNotResponsiveComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 2, "app-chips-list-notResponsive", [], null, null, null, View_ChipsListNotResponsiveComponent_0, RenderType_ChipsListNotResponsiveComponent)), i1.ɵdid(1, 4374528, null, 1, i2.ChipsListNotResponsiveComponent, [], null, null), i1.ɵqud(603979776, 1, { chips: 1 })], null, null); }
var ChipsListNotResponsiveComponentNgFactory = i1.ɵccf("app-chips-list-notResponsive", i2.ChipsListNotResponsiveComponent, View_ChipsListNotResponsiveComponent_Host_0, {}, {}, ["*"]);
export { ChipsListNotResponsiveComponentNgFactory as ChipsListNotResponsiveComponentNgFactory };



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/theme/components/chips/chips-list-notResponsive/chips-list-notResponsive.component.ngfactory.js.pre-build-optimizer.js